import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import Fade from '@mui/material/Fade';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import { DS_SIZE_MAP } from 'Components/ComponentLibrary/DesignSystem/sizes';
import OnboardingHeader from '../../../Components/Header';
import InfoBox from '../../../Components/InfoBox';
import Actions from '../../../Components/Actions';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  content: {
    maxWidth: theme.dimensions.xl,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  infoBox: {},
  noAccessMessage: {},
  noAccessMailToLink: {
    fontWeight: theme.typography.fontWeightBold,
  },
  actions: {
    width: '100%',
  },
  navigateButton: {},
});

const WebsiteAgreementDeclined = ({
  className,
  classes,
  navigateToAgreement,
}) => {
  return (
    <Fade in>
      <Box
        className={classNames(classes.root, className)}
      >
        <Box className={classes.content}>
          {/* ------- AGREEMENT HEADER ------- */}
          <OnboardingHeader
            title={'Are you sure?'}
            centered
          />
          <InfoBox
            className={classes.infoBox}
          >
            <Typography
              weight={'medium'}
              color={'primaryGray'}
              variant={'h6'}
              paragraph
            >
              {'In order to access the client portal, you must accept our website acknowledgement.'}
            </Typography>
            <Typography
              className={classes.noAccessMessage}
              weight={'medium'}
              color={'primaryGray'}
              variant={'h6'}
              paragraph
            >
              {'If you do not wish to accept, please '}
              <a
                href={'mailto:info@facetwealth.com'}
                className={classes.noAccessMailToLink}
              >
                {'contact us'}
              </a>.
            </Typography>
          </InfoBox>
          <Actions
            className={classes.actions}
          >
            <RoundedButton
              className={classes.navigateButton}
              onClick={navigateToAgreement}
              color={'primary'}
              variant={'contained'}
              size={DS_SIZE_MAP.sm}
              disableElevation
              fullWidth
              test={'website-agreement-declined-return-to-website-agreement'}
            >
              {'Back to Website Agreement'}
            </RoundedButton>
          </Actions>
        </Box>
      </Box>
    </Fade>
  );
};

WebsiteAgreementDeclined.defaultProps = {
  className: '',
};

WebsiteAgreementDeclined.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  navigateToAgreement: PropTypes.func.isRequired,
};

export default withStyles(styles)(WebsiteAgreementDeclined);
